import { render, staticRenderFns } from "./TypeEdit.vue?vue&type=template&id=3726d574"
import script from "./TypeEdit.vue?vue&type=script&lang=js"
export * from "./TypeEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports